<template>
  <div>
    <StatBlock :value="fmt(total)" unit="MWh in 2026" size="lg" class="mb-3" />
    <div class="position-relative">
      <div class="cg-bars" @mouseleave="hover = null">
        <button
          v-for="(row, i) in rows"
          :key="row.period"
          type="button"
          class="cg-bar cg-bar-btn cg-clickable"
          :aria-label="`${row.period}: ${fmt(row.total)} MWh, ${row.basis}. Open month detail`"
          @mouseenter="hover = i"
          @focus="hover = i"
          @blur="hover = null"
          @click="$emit('open-month', row.monthIndex)"
        >
          <div :style="{ height: row.barPct, background: FILL[row.fill] }" />
        </button>
      </div>
      <div class="cg-strip cg-axis">
        <span
          v-for="row in rows"
          :key="row.period"
          class="cg-strip-cell cg-micro text-center"
          >{{ row.period.replace(" 2026", "") }}</span
        >
      </div>
      <HoverPopover
        v-if="hoverCell"
        :cell="hoverCell"
        :left="popoverLeft"
        :flip="true"
        class="cg-top"
      />
    </div>
    <LegendSwatches :legend />
  </div>
</template>

<script setup lang="ts">
import type {
  LegendItem,
  PeriodRow,
  StripCell,
} from "@/compliance_groups/fixture/derive";
import { FILL } from "@/compliance_groups/fixture/fills";
import { fmt } from "@/compliance_groups/fixture/format";
import { computed, ref } from "vue";
import HoverPopover from "./HoverPopover.vue";
import LegendSwatches from "./LegendSwatches.vue";
import StatBlock from "./StatBlock.vue";

const props = defineProps<{
  rows: PeriodRow[];
  legend: LegendItem[];
  total: number;
}>();
defineEmits<{ "open-month": [monthIndex: number] }>();

const hover = ref<number | null>(null);
const hoverCell = computed<StripCell | null>(() => {
  if (hover.value === null) return null;
  const r = props.rows[hover.value];
  return {
    label: r.period,
    period: r.period,
    fill: r.fill,
    statusLabel: r.basis,
    tone: r.basisTone,
    detail: [
      { k: "Consumption", v: `${fmt(r.total)} MWh` },
      { k: "Points actual", v: r.pointsActual },
    ],
  };
});
const popoverLeft = computed(() => {
  if (hover.value === null) return "0px";
  const n = props.rows.length || 1;
  return `clamp(0px, calc(${(((hover.value + 0.5) / n) * 100).toFixed(2)}% - 116px), calc(100% - 232px))`;
});
</script>

<style scoped lang="scss">
.cg-bar-btn {
  border: 0;
  padding: 0;
  background: transparent;
}
.cg-top {
  top: 0 !important;
}
</style>
